module Widgets.Loading where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P

-- | A simple widget that displays a loading animation.
loadingWidget :: forall a. Widget HTML a
loadingWidget = D.div
  [ P.className "loading-spinner" ]
  [ D.text "Loading" ]

-- | A loading widget that renders on top of the entire page. Combine with
-- | something else using `<|>`.
loadingWidgetOverlay :: forall a. Widget HTML a
loadingWidgetOverlay = D.div
  [ P.className "loading-overlay" ]
  [ loadingWidget ]
